module.exports = __webpack_public_path__ + "static/brampton-0a6c8f7081a59f5ff269fb867beeb60a.jpg";